/**
 * HSE Metrics Display
 * Shows current state HSE metrics (POB, UA/UC, PTW, LTI-Free Hours, Toolbox Talks)
 */

import React from 'react';
import { format } from 'date-fns';
import './HSEMetricsDisplay.css';

const HSEMetricsDisplay = ({ entitiesWithYTD }) => {
  const hseMetrics = entitiesWithYTD.filter(e => 
    e.EntityType === 'Metric' && e.Category === 'HSE'
  );

  if (hseMetrics.length === 0) {
    return (
      <div className="hse-metrics-empty">
        <p>No HSE metrics configured.</p>
        <p>Add HSE metrics with Category = "HSE"</p>
      </div>
    );
  }

  const getLatestValue = (metric) => {
    if (metric.ytdMetrics && metric.ytdMetrics.latestValue != null) {
      return metric.ytdMetrics.latestValue;
    }
    return 0;
  };

  const getTimestamp = (metric) => {
    if (metric.ytdMetrics && metric.ytdMetrics.endDate) {
      return metric.ytdMetrics.endDate;
    }
    return null;
  };

  const getMetricIcon = (title) => {
    const t = title.toLowerCase();
    if (t.includes('pob') || t.includes('personnel')) return '👥';
    if (t.includes('ua') || t.includes('uc') || t.includes('unsafe')) return '⚠️';
    if (t.includes('ptw') || t.includes('permit')) return '📋';
    if (t.includes('lti') || t.includes('injury')) return '🎯';
    if (t.includes('toolbox')) return '🔧';
    return '📊';
  };

  const formatNumber = (num) => {
    if (num == null) return '0';
    return Math.round(num).toLocaleString();
  };

  return (
    <div className="hse-metrics-display">
      <div className="hse-header">
        <h3>🛡️ Health, Safety & Environment Metrics</h3>
      </div>

      <div className="hse-grid">
        {hseMetrics.map(metric => {
          const value = getLatestValue(metric);
          const timestamp = getTimestamp(metric);
          const icon = getMetricIcon(metric.Title);

          return (
            <div key={metric.Id} className="hse-card">
              <div className="hse-card-icon">{icon}</div>
              
              <div className="hse-card-content">
                <div className="hse-card-title">{metric.Title}</div>
                
                <div className="hse-card-value">
                  {formatNumber(value)}
                  {metric.TargetUnit && (
                    <span className="hse-unit">{metric.TargetUnit}</span>
                  )}
                </div>

                {metric.TargetValue && (
                  <div className="hse-target">
                    Target: {formatNumber(metric.TargetValue)} {metric.TargetUnit}
                  </div>
                )}

                {timestamp && (
                  <div className="hse-timestamp">
                    Updated: {format(new Date(timestamp), 'MMM dd, HH:mm')}
                  </div>
                )}

                {metric.Description && (
                  <div className="hse-description">{metric.Description}</div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default HSEMetricsDisplay;